export default "__VITE_ASSET__PoQbjvF7__"